import { useProductsByIdsQuery } from "client/graphql/storefront-api"

import { isProduct } from "../utils/isProduct"

import { useShopContext } from "./ShopContext"

export function useFeaturedProduct() {
  const { shop } = useShopContext()
  const activeSale = shop?.activeSale

  const { data, loading } = useProductsByIdsQuery({
    variables: { ids: [activeSale?.featuredProductId ?? ""] },
    context: { useStorefrontAPI: true },
    skip: !activeSale?.featuredProductId,
  })

  const product = data?.products[0]

  return {
    loading,
    product: isProduct(product) ? product : null,
  }
}
